<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <template v-slot:activator="{ on }">
      <v-btn text class="px-1" v-on="on">
        {{ text }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        Reset my password
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="email"
          label="E-mail"
          :error-messages="errors"
          required
          @keyup.enter="send"
        />
      </v-card-text>
      <v-card-text
        >To reset your password, enter the email address you use and we will
        send you further instructions by e-mail.</v-card-text
      >
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="
            dialog = false
            $v.$reset()
          "
        >
          Cancel
        </v-btn>
        <v-btn depressed @click="send">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { validationMixin } from "vuelidate"
import { required, email } from "vuelidate/lib/validators"
import { AccountService } from "@/services"
export default {
  mixins: [validationMixin],
  validations: {
    email: { email, required }
  },
  props: {
    text: {
      type: String,
      default: () => "Password forgotten ?"
    }
  },
  data() {
    return {
      dialog: false,
      email: ""
    }
  },
  computed: {
    errors() {
      const errors = []
      if (this.$v.email.$dirty) {
        if (!this.$v.email.email) {
          errors.push("Email is not valid")
        }
        if (!this.$v.email.required) {
          errors.push("Email is required")
        }
      }

      return errors
    }
  },
  methods: {
    send() {
      const self = this
      this.$v.$touch()
      if (!this.$v.$invalid) {
        AccountService.resetPassword(self.email, self).then(() => {
          self.dialog = false
        })
      }
    }
  }
}
</script>
